import { gql } from "@apollo/client"
import { USER_GROUPS_COMPANIES_FRAG } from "./user/user.fragments.gql"

// Fragments

export const FARMER_FRAGMENTS = {
  farmerDetails: gql`
    fragment FarmerDetailsFrag on BaseUserType {
      id
      firstName
      lastName
      number
      secondaryNumbers {
        id
        number
      }
      isBlocked
      blockRemark
      referenceId
      companyCode
      email
      username
      ...UserGroupsCompaniesFrag
      dateOfBirth
      gender
      education
      kycDetails {
        id
        kycType {
          id
          name
        }
        idNumber
      }
      address {
        id
        village
        address
        pincode
        taluka
        state
        district
        latitude
        longitude
      }
      bankDetails {
        id
        bank {
          id
          name
        }
        attachments {
          id
          url
          mediaType
        }
        ifscCode
        branchName
        accountNumber
        accountHolderName
      }
    }
    ${USER_GROUPS_COMPANIES_FRAG}
  `,
  farmerList: gql`
    fragment FarmerListFrag on BaseUserType {
      id
      fullName
      createdAt
      username
      isBlocked
      blockRemark
      companyCode
      groups {
        id
        name
      }
      plots {
        id
        codename
        crops {
          id
          variety {
            id
            name
          }
        }
      }
      number
      status
    }
  `,
}
export const FARMER_LIST = gql`
  query allFarmersList(
    $query: String
    $group: String
    $first: Int
    $skip: Int
  ) {
    usersByGroup(query: $query, groupName: $group, first: $first, skip: $skip) {
      ...FarmerListFrag
    }
  }
  ${FARMER_FRAGMENTS.farmerList}
`
export const FARMER_DETAILS = gql`
  query farmerDetails($id: Int!) {
    userDetails(userId: $id) {
      ...FarmerDetailsFrag
    }
  }
  ${FARMER_FRAGMENTS.farmerDetails}
`
export const ADD_FARMER = gql`
  mutation addFarmer($farmer: FarmerInput) {
    addUpdateOnlyFarmer(user: $farmer) {
      user {
        ...FarmerDetailsFrag
      }
    }
  }
  ${FARMER_FRAGMENTS.farmerDetails}
`
